import React from 'react'

const Social = () => {
    return (
        <div className='home__social'>
            <a href="https://www.linkedin.com/in/dharmendra9503" className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-linkedin"></i>
            </a>

            <a href="https://www.instagram.com/ll_dharmendra_lll" className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-instagram"></i>
            </a>

            <a href="https://github.com/dharmendra9503" className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-github"></i>
            </a>
        </div>
    )
}

export default Social
